import React from 'react';
import {useTranslation} from 'react-i18next';
import {Theme, ThemeName} from '@taopix/taopix-design-system';

const PricingKey = () => {
  const {t} = useTranslation(['assetservices']);
  return (
    <Theme name={ThemeName.Information} className="border-2 mb-sm p-sm">
      <div>
        {t('str_MessageAllPicturesAreFreeOfChange', {
          ns: 'assetservices',
        })}
      </div>
      <ul>
        <li>
          *{' '}
          {t('str_MessagePicturesAreChargedOnce', {
            ns: 'assetservices',
          })}
        </li>
        <li>
          **{' '}
          {t('str_MessagePicturesAreChargedEvery', {
            ns: 'assetservices',
          })}
        </li>
      </ul>
    </Theme>
  );
};

export default PricingKey;
